import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60104c5d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "widgetTitle mb-0" }, "STAR rating", -1))
const _hoisted_2 = { class: "movementIconsContainer" }
const _hoisted_3 = { class: "firstLine" }
const _hoisted_4 = { class: "firstLine" }
const _hoisted_5 = { class: "secondLine" }
const _hoisted_6 = { class: "firstLine" }
const _hoisted_7 = { class: "secondLine" }
const _hoisted_8 = { class: "mt-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_country_name_bar = _resolveComponent("country-name-bar")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_container = _resolveComponent("v-container")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.country && _ctx.country.riskData && _ctx.country.riskData.length>0 )
    ? (_openBlock(), _createBlock(_component_v_container, {
        key: 0,
        class: _normalizeClass({'isMobile': _ctx.isMobile})
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { class: "countryNameBar__holder ma-0" }, {
            default: _withCtx(() => [
              _createVNode(_component_country_name_bar, {
                countryName: _ctx.country.country_name
              }, null, 8, ["countryName"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, {
            class: _normalizeClass(["widgetTitle__holder mb-0", {'mt-15' : !_ctx.isMobile}])
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_v_row, { class: "contentRow" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                md: "6",
                cols: "12",
                class: "pa-0 ma-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { class: "d-flex" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        md: "auto",
                        cols: "6",
                        class: "pa-0 ma-0"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            class: _normalizeClass('star_score_text _' + _ctx.country.riskData[0].star),
                            style: _normalizeStyle('color:' + _ctx.country.riskCategoryObject.color)
                          }, _toDisplayString(_ctx.formatRiskCategory(_ctx.country.riskData[0].star)), 7),
                          _createElementVNode("span", _hoisted_2, [
                            _withDirectives((_openBlock(), _createBlock(_component_v_icon, { class: "lineItem movementInfoIcon" }, {
                              default: _withCtx(() => [
                                _createTextVNode("mdi-information-outline")
                              ]),
                              _: 1
                            })), [
                              [_directive_tooltip, _ctx.tooltipData()]
                            ]),
                            (_ctx.country.riskData[0].difference < 0)
                              ? (_openBlock(), _createBlock(_component_v_icon, {
                                  key: 0,
                                  class: "lineItem movementArrowIcon"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("mdi-arrow-up")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.country.riskData[0].difference > 0)
                              ? (_openBlock(), _createBlock(_component_v_icon, {
                                  key: 1,
                                  class: "lineItem movementArrowIcon"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("mdi-arrow-down")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.country.riskData[0].difference !== 0)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 2,
                                  class: "lineItem movementDirectionText",
                                  style: _normalizeStyle('color:' + _ctx.getHexColor(_ctx.country.riskData[0].star_previous_quarter))
                                }, _toDisplayString(_ctx.country.riskData[0].star_previous_quarter), 5))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }),
                      (!_ctx.isMobile)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 0,
                            cols: "6",
                            md: "6",
                            class: "ml-4"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, { class: "riskTitleTextDesktop riskTitleText pt-4" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    md: "12",
                                    cols: "12"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_3, [
                                        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.correctRiskWording(_ctx.country.riskCategoryObject.risk)[0]), 1)
                                      ]),
                                      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.correctRiskWording(_ctx.country.riskCategoryObject.risk)[1]), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, { class: "riskTitleTextMobile riskTitleText" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    md: "12",
                    cols: "12"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.correctRiskWording(_ctx.country.riskCategoryObject.risk)[0]), 1),
                      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.correctRiskWording(_ctx.country.riskCategoryObject.risk)[1]), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                md: "6",
                cols: "12",
                class: "starDescriptionText pa-0 ma-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.countryRiskParagraph), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"]))
    : _createCommentVNode("", true)
}